import React, { useEffect, useContext } from "react"
// import SEO from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/Seo"
import Header from "./Header"
import { Helmet } from "react-helmet"
import Footer from "./Footer"
import { NavContext } from "@yumgmbh/gatsby-plugin-sb-nav/src/context/NavContext"

const Layout = ({ children, showHeader = true }) => {
  const { navData } = useContext(NavContext) || { navData: {} }

  useEffect(() => {
    if (document?.location?.pathname === "/storyblok-preview/") {
      setTimeout(() => {
        if (document.querySelector(".cm-btn.cm-btn-success")) {
          document.querySelector(".cm-btn.cm-btn-success").click()
        }
      }, 100)
    }
  })

  return (
    <div className="flex flex-col min-h-screen">
      {showHeader === true && (
        <Header navData={navData?.mainNavigation?.navigation} />
      )}
      {/* <SEO title="Test"></SEO> */}
      <Helmet
        htmlAttributes={{ lang: "de", class: "bg-secondary scroll-smooth" }}
        bodyAttributes={{
          class: "theme-default bg-white font-body font-medium",
        }}
      >
        <script
          type="text/plain"
          data-name="googleanalytics"
          data-type="application/javascript"
        >
          {`
            (function(i, s, o, g, r, a, m) {
              i['GoogleAnalyticsObject'] = r;
              i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments)
              }, i[r].l = 1 * new Date();
              a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
              a.async = 1;
              a.src = g;
              m.parentNode.insertBefore(a, m)
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

            ga('create', '${process.env.GATSBY_GA_KEY}', 'auto');
            ga('set', 'anonymizeIp', true);
            ga('send', 'pageview');
          `}
        </script>
      </Helmet>
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
